export enum ToastType {
  SUCCESS = 'success',
  DANGER = 'danger',
  INFO = 'info',
  WARNING = 'warning',
}

export interface ToastLink {
  label: string;
  href: string;
}

export interface Toast {
  type: ToastType;
  message: string;
  details: string;
  links: ToastLink[];
  correlationId?: string;
}

export type Dictionary<T = unknown> = Record<string, T>;

export type Option = { label: string; value: string; };
export type Options = Option[];

// See https://basarat.gitbooks.io/typescript/content/docs/tips/nominalTyping.html
// also see https://github.com/Microsoft/TypeScript/issues/28079: "The nominal typing is example above is flawed"
interface Nominal<T/*: must be an enum or a literal */> {
  'nominal structural brand': T;
}

// A DateString represents a location dependant date (without a time.)
// For example, 2019-07-25 in Zurich represents the 24h period from 2019-07-24T22:00:00
// until 2019-07-25T22:00:00 with the end being exclusively compared.
enum DateStringBrand {}
export type DateString = string & Nominal<DateStringBrand>;

enum LocationKeyBrand {}
export type LocationKey = string & Nominal<LocationKeyBrand>;
